// Estado de candados del menú (ver utilities/menuLocks.ts).
//
// Fuentes de verdad EXISTENTES, no se inventa ninguna:
//   - Add-on Fidelización: `GET /loyalty/status` → { enabled (kill-switch),
//     addonActive } — el mismo endpoint que decide si /fidelizacion muestra el
//     módulo o la invitación a contratar (useLoyaltyAddon).
//   - Features de plan: `GET /account/plan-features` vía el cache compartido
//     de usePlanGate (el mismo que usa <PlanGate> en las rutas).
//
// El add-on cambia en caliente (se contrata desde la propia pantalla), por
// eso se re-consulta cada vez que cambia `refreshKey` (el menú lo incrementa
// al abrirse). Una consulta por apertura: el endpoint es liviano.
import { useEffect, useState } from "react";
import { fetchLoyaltyStatus } from "@/modules/loyalty/services/loyaltyService";
import { getPlanFeatures, PLAN_FEATURES_CHANGED } from "@/hooks/usePlanGate";
import { EMPTY_MENU_LOCK_STATE, MenuLockState } from "../utilities/menuLocks";

export const useMenuLockState = (refreshKey: number = 0): MenuLockState => {
  const [state, setState] = useState<MenuLockState>(EMPTY_MENU_LOCK_STATE);

  useEffect(() => {
    let alive = true;
    fetchLoyaltyStatus()
      .then((status) => {
        if (!alive) return;
        setState((prev) => ({
          ...prev,
          addons: {
            ...prev.addons,
            fidelizacion: {
              available: status.enabled,
              active: status.enabled ? status.addonActive : null,
            },
          },
        }));
      })
      .catch(() => {
        // Error de red: se conserva lo último conocido (al inicio, oculto).
      });
    return () => {
      alive = false;
    };
  }, [refreshKey]);

  useEffect(() => {
    let alive = true;
    const load = () =>
      getPlanFeatures().then((planFeatures) => {
        if (alive && planFeatures) setState((prev) => ({ ...prev, planFeatures }));
      });
    load();
    window.addEventListener(PLAN_FEATURES_CHANGED, load);
    return () => {
      alive = false;
      window.removeEventListener(PLAN_FEATURES_CHANGED, load);
    };
  }, []);

  return state;
};
